import { Grid } from "@mui/material";
import React, { memo } from "react";
import SectionContainer from "../../../common/SectionContainer";
import Surcharge from "../../../common/Surcharge";

const EditMerchantSurchargeComponent = (prop: { isUpdateAllowed: boolean }) => {
  const { isUpdateAllowed } = prop;
  return (
    <Grid item xs={12}>
      <SectionContainer name="sections.Surcharge" heading="Surcharge">
        <Surcharge isUpdateAllowed={isUpdateAllowed} />
      </SectionContainer>
    </Grid>
  );
};

export default memo(EditMerchantSurchargeComponent);
